import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';
import { ISectionAddRequest } from '@core/interfaces/isections';

@Injectable({
  providedIn: 'root'
})
export class SectionService {

  constructor(private data: DataService) { }

  add(payload: ISectionAddRequest, message?: string): Observable<any> {
    return this.data.post('section', payload, message);
  }
}
